import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BusinessService } from '@app/business/business.service';
import { SessionStorageService } from '@app/core/local-storage/local-storage.service';
import { BissService } from '@app/shared/services/biss.service';
import { catchError, forkJoin, of, switchMap, tap } from 'rxjs';
import { ActionAuthLoginSuccess } from '../../auth.reducer';
import { Store } from '@ngrx/store';
import { ManageService } from '@app/certificates/manage/manage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cloud-open-biss',
  templateUrl: './open-biss.component.html',
  styleUrls: ['./open-biss.component.scss']
})
export class OpenBissComponent implements OnInit, OnDestroy {
  @Input()
  url = 'bissopen:start';
  urlSafe: SafeResourceUrl;
  token: any;

  contents: any;
  signedContents: any;
  signedContentsCert: any;
  contentType: any;
  content: any;
  signedContent: any;
  signedContentCert: any;
  signaturesFromSign: any;
  contentFromSign: any;
  certificateFromSign: any;
  usedPort: any;

  cmrId: any;
  personalId: any;

  constructor(
    public sanitizer: DomSanitizer,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public bissService: BissService,
    private dialog: MatDialog,
    public businessService: BusinessService,
    public manageService: ManageService,
    private store: Store<any>,
    public translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: OpenBissComponent
  ) { }

  ngOnInit() {
    this.bissService.usedCert$.subscribe(cert => {
      this.signedContentCert = cert;
    });

    this.getPort()
    this.signMethod();
  }
  getPort() {
    this.bissService.getBissPort().subscribe((res: any) => {
      this.usedPort = res
    })
  }

  signMethod() {
    const contents = this.data?.data.content ? [this.data.data.content] : [];
    const signedContents = this.data?.data.signedContent ? [this.data.data.signedContent] : [];
    const signedContentsCert = this.data?.data.signedContentCert ? [this.data.data.signedContentCert] : [];

    if (!contents.length || !signedContents.length || !signedContentsCert.length) {
      console.error("Missing required data for signing!");
      return;
    }

    let payload = {
      version: "2.16",
      contents,
      signedContents,
      signedContentsCert,
      contentType: "digest",
      hashAlgorithm: "SHA256",
      signatureType: "signature",
      signerCertificateB64: this.signedContentCert,
      confirmText: null
    };

    this.certificateFromSign = this.signedContentCert;
    this.contentFromSign = payload.contents;

    this.bissService.signBiss(payload).pipe(
      switchMap((res: any) => {
        if (res?.status === 200) {
          this.signaturesFromSign = res.signatures[0];
          return this.bissService.postBiss({
            signature: String(this.signaturesFromSign),
            content: String(this.contentFromSign),
            certificate: String(this.certificateFromSign)
          });
        }
        return of(null);
      }),
      switchMap((response: any) => {
        if (!response) {
          return of(null);
        }
        this.cmrId = response?.data?.userData?.cmrId;
        const authData = {
          isAuthenticated: response?.data?.authenticated,
          userData: response?.data?.userData,
        };

        const settings = response?.data?.settings;
        const nomenclature = response?.data?.nomenclature;

        this.sessionStorageService.setRootItem('auth', authData);
        this.sessionStorageService.setRootItem('settings', settings);
        this.sessionStorageService.setRootItem('nomenclature', nomenclature);

        this.businessService.getCompanies(this.cmrId).subscribe(res => {
          console.log('getCompanies',res)
          
          if (res.data && res.data.length > 0) {
            this.sessionStorageService.setItem("accounts", res.data);
            this.sessionStorageService.setItem("loginEventData", response?.data);
            this.router.navigateByUrl('/accounts');
          } else {
            this.sessionStorageService.setItem("loginEventData", response?.data);
            this.store.dispatch(new ActionAuthLoginSuccess({ auth: response?.data }));
            this.router.navigateByUrl('/manage/signing');
          }
        })

      }),
      catchError(error => {
        this.dialog.closeAll();
        return of(null);
      })
    ).subscribe((result: any) => {
      if (result !== null) {
        this.dialog.closeAll();
      }
    });
  }

  ngOnDestroy() {
  }
}
